export default __webpack_public_path__ + "static/media/error-boundary.cd658c07.svg";